import { render, staticRenderFns } from "./JsonObjectListEditor.vue?vue&type=template&id=54e03d64&scoped=true&"
import script from "./JsonObjectListEditor.vue?vue&type=script&lang=js&"
export * from "./JsonObjectListEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonObjectListEditor.vue?vue&type=style&index=0&id=54e03d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e03d64",
  null
  
)

export default component.exports